import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {SpringPageable} from './spring-pageable';
import {PageStatementDTO} from '../model/pageStatementDTO';

@Injectable({
  providedIn: 'root'
})
export class StatementService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'statement';

  constructor(private http: HttpClient) {
  }

  get(accountId: number, pageable: SpringPageable) {
    return this.http.get<PageStatementDTO>(`${this.path}/overview/${accountId}`, {params: pageable.toHttpParams()});
  }

  getPageNumberByDate(accountId: number, date: string, pageSize: number) {
    return this.http.get<number>(`${this.path}/overview/${accountId}/page-number?date=${date}&page-size=${pageSize}`);
  }
}
